export function updateAnnouncements(state, value) {
  state.announcements = value;
}

export function updateExclusives(state, value) {
  console.log(value);
  state.exclusives = value;
}

export function updateUploadProgress(state, value) {
  state.uploadProgress = value;
}

export function updatePins(state, value) {
  state.pins = value;
}

export function updateChats(state, value) {
  state.chats = value;
}

export function updateDataStream(state, value) {
  state.dataStreamItems = value;
}

export function updateChatStream(state, value) {
  state.chatStreamItems = value;
}

export function updateCampaigns(state, value) {
  state.campaigns = value;
}

export function updatePerks(state, value) {
  state.perks = value;
}
